const AppTheme = {
    'theme-light': {
        textColor: "#000",
        color: '',
        backgroundColor: "#fff",
        backgroundBody: '#fafafa',
        boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.05)',
        backgroundImageArrow: 'url(/assets/image/down-arrow.svg)'
    },
    'theme-dark': {
        textColor: "#fff",
        color: '',
        backgroundColor: "#2b3743",
        backgroundBody: '#202d36',
        boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.05)',
        backgroundImageArrow: 'url(/assets/image/down-arrow-white.svg)'
    }
}

export default AppTheme;